import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RolePermissionState, ROLE_PERMISSION_FEATURE_KEY } from './role-permission.reducer';
import { ListRolesRequest } from '../../models/rolePermission.model';

export const selectRolePermissionState = createFeatureSelector<RolePermissionState>(ROLE_PERMISSION_FEATURE_KEY);

export const selectRolePermission = createSelector(
  selectRolePermissionState,
  (state) => state.rolePermission
);

export const selectRolePermissionLoading = createSelector(
  selectRolePermissionState,
  (state) => state.loading
);

export const selectRolePermissionError = createSelector(
  selectRolePermissionState,
  (state) => state.error
);

export const selectRolePermissioinList = createSelector(
  selectRolePermissionState,
  (state) => state.roleList
);

export const selectSystemRoleList = createSelector(
  selectRolePermissionState,
  (state) => state.systemRolelist
);

export const selectRoleNames = createSelector(
  selectRolePermissionState,
  (state) => state.roleNames
);

export const selectAllModulePermissions = createSelector(
  selectRolePermissionState,
  (state) => state.allModulePermissions
);

export const currentRolePermission = createSelector(
  selectRolePermissionState,
  (state) => state.role
);

export const selectRolePagination = createSelector(
  selectRolePermissionState,
  (state) => ({
    total: state.total,
    page: state.currentPage,
    limit: state.limit
  })
);

export const selectAssignedRoleData = createSelector(
  selectRolePermissionState,
  (state) => state.assignedRoleData?.data
);

export const getRolesQueries = createSelector(
  selectRolePermissionState,
  (state) =>
    ({
      params: {
        limit: 10,
        // limit: state.limit,
        page: state.page,
      },
      body: {
        filter: state.filter,
        sort: state.sort,
      },
    } as ListRolesRequest)
);
